export const mens_kurta = [
  {
    imageUrl: "https://example.com/kurta1.jpg",
    brand: "Majestic Man",
    title: "Men Printed Pure Cotton Straight Kurta",
    color: "Green",
    discountedPrice: "₨ 1,499",
    price: "₨ 2,999",
    discountPersent: 50,
    size: [
      { name: "S", quantity: 20 },
      { name: "M", quantity: 30 },
      { name: "L", quantity: 50 },
    ],
    quantity: 100,
    topLavelCategory: "Men",
    secondLavelCategory: "Clothing",
    thirdLavelCategory: "mens_kurta",
    description: "A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style.",
  },
  {
    imageUrl: "https://example.com/kurta2.jpg",
    brand: "SG LEMAN",
    title: "Men Embroidered Jacquard Straight Kurta",
    color: "Yellow",
    discountedPrice: "₨ 1,799",
    price: "₨ 3,499",
    discountPersent: 49,
    size: [
      { name: "S", quantity: 20 },
      { name: "M", quantity: 30 },
      { name: "L", quantity: 50 },
    ],
    quantity: 100,
    topLavelCategory: "Men",
    secondLavelCategory: "Clothing",
    thirdLavelCategory: "mens_kurta",
    description: "A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style.",
  },
  {
    imageUrl: "https://example.com/kurta3.jpg",
    brand: "FUBAR",
    title: "Men Printed Cotton Blend Straight Kurta",
    color: "Blue",
    discountedPrice: "₨ 1,299",
    price: "₨ 2,599",
    discountPersent: 50,
    size: [
      { name: "S", quantity: 20 },
      { name: "M", quantity: 30 },
      { name: "L", quantity: 50 },
    ],
    quantity: 100,
    topLavelCategory: "Men",
    secondLavelCategory: "Clothing",
    thirdLavelCategory: "mens_kurta",
    description: "A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style.",
  },
  {
    imageUrl: "https://example.com/kurta4.jpg",
    brand: "ALY JOHN",
    title: "Men Solid Pure Cotton Straight Kurta",
    color: "White",
    discountedPrice: "₨ 1,999",
    price: "₨ 3,999",
    discountPersent: 50,
    size: [
      { name: "S", quantity: 20 },
      { name: "M", quantity: 30 },
      { name: "L", quantity: 50 },
    ],
    quantity: 100,
    topLavelCategory: "Men",
    secondLavelCategory: "Clothing",
    thirdLavelCategory: "mens_kurta",
    description: "A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style.",
  },
  {
    imageUrl: "https://example.com/kurta5.jpg",
    brand: "PETER ENGLAND",
    title: "Men Woven Design Pure Cotton Straight Kurta",
    color: "Grey",
    discountedPrice: "₨ 1,499",
    price: "₨ 2,999",
    discountPersent: 50,
    size: [
      { name: "S", quantity: 20 },
      { name: "M", quantity: 30 },
      { name: "L", quantity: 50 },
    ],
    quantity: 100,
    topLavelCategory: "Men",
    secondLavelCategory: "Clothing",
    thirdLavelCategory: "mens_kurta",
    description: "A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style.",
  },
];